import script from "./ContentPreviewButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentPreviewButton.vue?vue&type=script&setup=true&lang=js"

import "./ContentPreviewButton.vue?vue&type=style&index=0&id=aa2b7ccc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa2b7ccc"]])

export default __exports__